import { makeObservable, observable } from 'mobx'

class ListStore {
  /**
   * 将初始化的步骤移动到 constructor 中，
   * 并且请务必初始化，否则 babel 插件 plugin-transform-flow-strip-types 编译失败，
   * 相关联 issue: 
   * https://github.com/react-navigation/react-navigation/issues/5825#issuecomment-590723220
   * https://github.com/facebook/react-native/issues/20150#issuecomment-417858270
   */
  /**
   * 更新对象类型的 store 时候，
   * 除非要观察整个对象，否则禁止完全重写整个对象，
   * 因为完全重写会导致观察该对象的所有组件都重新渲染
   */
  // ListTable Context
  table: Map<string | undefined, any>

  constructor () {
    this.table = new Map()

    makeObservable(this, {
      /**
       * 需要将其添加到 observable 中
       * 否则在 listStore.table.get 的时候很可能只返回 undefined
       */
      table: observable,
    })
  }
}

const listStore = new ListStore()
export default listStore